/**
 * 到店客户模拟数据
 * http://mockjs.com/
 */
import Mock from 'mockjs'
import cache from '../../common/cache'
let mock = cache.getSessionData('mock')
// mock 开关
let mockSwitch = mock ? '' : '_'

// 到店转成交统计 - 到店客户
Mock.mock(/sale_report\/arrive_to_deal_analysis/, 'get' + mockSwitch, {
  'code': 0,
  'data': [
    {
      'arrived': '5',
      'deal': 11,
      'deal_rate': 0.01,
      'review': 11,
      'arrived_type': '首次到店'
    },
    {
      'arrived': '5',
      'deal': 11,
      'deal_rate': 0.01,
      'review': 11,
      'arrived_type': '二次到店'
    },
    {
      'arrived': '5',
      'deal': 11,
      'deal_rate': 0.01,
      'review': 11,
      'arrived_type': '合计'
    }
  ],
  'message': 'ok'
})

// 意向车型转成交统计 - 到店客户
Mock.mock(/sale_report\/intention_car_statistical_analysis/, 'get' + mockSwitch, {
  'code': 0,
  'data': [
    {
      'arrived': '5',
      'arrived_rate': '0.1',
      'deal': '5',
      'deal_rate': '0.1',
      'deal_total_rate': '0.1',
      'car_series': 'CT'
    },
    {
      'arrived': '5',
      'arrived_rate': '0.1',
      'deal': '5',
      'deal_rate': '0.1',
      'deal_total_rate': '0.1',
      'car_series': 'IS'
    },
    {
      'arrived': '5',
      'arrived_rate': '0.1',
      'deal': '5',
      'deal_rate': '0.1',
      'deal_total_rate': '0.1',
      'car_series': 'ES'
    },
    {
      'arrived': '5',
      'arrived_rate': '0.1',
      'deal': '5',
      'deal_rate': '0.1',
      'deal_total_rate': '0.1',
      'car_series': '综合占比'
    },
    {
      'arrived': '5',
      'arrived_rate': '0.1',
      'deal': '5',
      'deal_rate': '0.1',
      'deal_total_rate': '0.1',
      'car_series': '其他'
    },
    {
      'arrived': '5',
      'arrived_rate': '0.1',
      'deal': '5',
      'deal_rate': '0.1',
      'deal_total_rate': '0.1',
      'car_series': '合计'
    }
  ],
  'message': 'ok'
})

// 客户区域分布转成交统计 - 到店客户
Mock.mock(/sale_report\/customer_area_statistical_analysis/, 'get' + mockSwitch, {
  'code': 0,
  'data': [
    {
      'arrived': '5',
      'arrived_rate': '0.1',
      'deal': '5',
      'deal_rate': '0.1',
      'deal_total_rate': '0.1',
      'area': '宝安区'
    },
    {
      'arrived': '5',
      'arrived_rate': '0.1',
      'deal': '5',
      'deal_rate': '0.1',
      'deal_total_rate': '0.1',
      'area': '综合占比'
    },
    {
      'arrived': '5',
      'arrived_rate': '0.1',
      'deal': '5',
      'deal_rate': '0.1',
      'deal_total_rate': '0.1',
      'area': '其他'
    },
    {
      'arrived': '5',
      'arrived_rate': '0.1',
      'deal': '5',
      'deal_rate': '0.1',
      'deal_total_rate': '0.1',
      'area': '合计'
    }
  ],
  'message': 'ok'
})

// 意向级别 - 到店客户
Mock.mock(/sale_report\/customer_intention_statistical_analysis/, 'get' + mockSwitch, {
  'code': 0,
  'data': {
    'items': [
      {
        'level': 'O级',
        'rate': 0.02,
        'total': 123
      },
      {
        'level': '1级',
        'rate': 0.1,
        'total': 123
      }
    ],
    'total': 456
  },
  'message': 'ok'
})
